<script>
import api from '@/api'
import { alertSuccess, alertConfirm } from '@/helpers/swal'
import pagination from '@/components/pagination.vue'

export default {
  data() {
    return {
      loading: true,
      pagetitle: 'Categories',
      categories: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 10,
      baseUrl: `${window.apiUrl}/category/getCategories/list`,
    }
  },
  components: {
    pagination,
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      const params = {
        page: this.currentPage,
        size: this.perPage,
      }
      api
        .get(this.baseUrl, {params})
        .then((response) => {
          this.categories = response.data?.categories || []
          this.totalPages = response.data.totalPages
          this.totalItems = response.data.totalItems  
          this.currentPage = response.data.currentPage
        })
        .finally(() => {
          this.loading = false
        })
    },

    deleteCategory(id) {
      alertConfirm('You want to delete this category').then((result) => {
        if (result.value) {
          api.post(`/category/delete/${id}`).then(() => {
            alertSuccess('Category deleted successfully')
            this.getCategories()
          })
        }
      })
    },

    updatePage(newPage) {
      this.currentPage = newPage - 1
      this.getCategories() 
    },

    showActionColumn() {
      return this.authUserHasPermission('device_category_edit') || this.authUserHasPermission('device_category_delete')
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-4 col-md-6">
              <!-- <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div> -->
            </div>
            <div class="col-md-6 col-lg">
              <div class="d-flex justify-content-end">
                <router-link v-if="authUserHasPermission('device_category_add')" to="/categories/create" class="btn btn-primary d-flex align-items-center gap-1">
                  <i class="bx bx-plus"></i>
                  Add New
                </router-link>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th v-if="showActionColumn()">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in showActionColumn() ? 3 : 2" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="categories.length">
                      <tr v-for="(category, index) in categories" :key="index">
                        <td>
                          <router-link :to="{ name: 'devices', query: { status: undefined, category: category.categoryName } }" title="Show Devices">
                            {{ category.categoryName }}
                          </router-link>
                        </td>
                        <td>{{ category.categoryDescription }}</td>
                        <td v-if="showActionColumn()">
                          <div class="d-flex gap-2">
                            <router-link
                              v-if="authUserHasPermission('device_category_edit')"
                              :to="'/categories/' + category.id + '/edit'"
                              class="btn btn-primary bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit"
                            >
                              <eva-icon name="edit" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </router-link>
                            <button
                              v-if="authUserHasPermission('device_category_delete')"
                              type="button"
                              class="btn btn-danger bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Delete"
                              @click="deleteCategory(category.id)"
                            >
                              <eva-icon name="trash-2" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="3" class="text-center">No categories found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && categories.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
</template>
